module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"metavariable":"Metavariable","metavariable_name":"Metavariable name","metavariable_type":"Metavariable type","value":"Value"},"fr":{"metavariable":"Métavariable","metavariable_name":"Nom de la métavariable","metavariable_type":"Type de la métavariable","value":"Valeur"}}')
  delete Component.options._Ctor
}
